exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".srcDownload .container[data-v-1c0a22c3]{display:-webkit-box;display:-ms-flexbox;display:flex}.srcDownload .container .main-img[data-v-1c0a22c3]{width:50%;height:600px;overflow:scroll}.srcDownload .container .main-img img[data-v-1c0a22c3]{width:375px}.srcDownload .container .info[data-v-1c0a22c3]{width:50%;padding:0 20px}.srcDownload .container .info .item[data-v-1c0a22c3]{margin-bottom:20px}.srcDownload .container .info .item label[data-v-1c0a22c3]{display:inline-block;width:100px}", ""]);

// exports
